/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    shape, arrayOf, object, string, bool, array,
} from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import DeliveryTable from '../../../DeliveryTable/DeliveryTable';
import CountDownTimerBanner from '../CountDownTimerBanner/CountDownTimerBanner';
import { getPresentationFamily } from '../../../../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getBrand } from '../../../../../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { getDataDictionary } from '../../../../../../../../../../state/ducks/App/App-Selectors';

const styles = (theme) => ({
    mobileImocContainer: {
        margin: '0 -15px 15px -15px', // negative to stretch full-width because of site wrapper margin
        boxShadow: '2px 2px 6px rgba(0,0,0,0.1)',
        padding: '0 15px',
    },
    mobileImocBackgorundContainer: {
        background: theme?.palette?.common?.lightPurple || '#f4f2f7',
    },
    innerContainer: {
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'space-between',
        lineHeight: '50px',
        width: '100%',
        '& h1': {
            margin: 0,
            fontSize: '16px',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
        },
    },
    imocReadMoreCopy: {
        paddingBottom: '20px',
        '& p, h2, h3, h4, h5, h6': {
            fontSize: '15px',
            margin: 0,
            padding: 0,
            textAlign: 'justify',
        },
    },

    imgLogo: {
        width: '100%',
    },

    imocClose: {
        color: theme.palette.colorPrimary,
    },
    flowerInnerContainer: {
        alignItems: 'baseline',
        justifyContent: 'space-between',
        float: 'left',
        width: '75%',
        '& h1': {
            fontSize: '16px',
            fontWeight: 'bold',
            textTransform: 'uppercase',
        },
    },
    flowerImocClose: {
        color: theme.palette.colorPrimary,
        width: '24%',
        float: 'right',
        paddingTop: '9px',
        textAlign: 'right',
    },
    flowerImocReadMoreCopy: {
        paddingBottom: '20px',
        '& p, h2, h3, h4, h5, h6': {
            fontSize: '15px',
            margin: 0,
            padding: 0,
        },
    },
    moreText: {
        height: 'auto',
        width: '100%',
        overflow: 'hidden',
    },
    lessText: {
        overflow: 'hidden',
        height: '0',
    },
    toggleButton: {
        outline: 'transparent',
        fontSize: '16px',
        padding: 0,
        margin: 0,
        border: 'none',
        background: 'transparent',
        color: theme.palette.colorPrimary,
        whiteSpace: 'nowrap',
    },
});

const MobileImoc = ({
    imocBlock, classes, samedayCutoff, presentation_family, brandData, language, dataDictionary,
}) => {
    let header;
    let exposeCopy;
    let imocReadMoreCopy;
    let imocShowSameDay;
    let imageImoc;
    let title;

    if (imocBlock) {
        imocBlock.forEach((block) => {
            // To Do: temp fix(block.name) to render imocs for (cco/18b) will all brands use web imoc like flowers?
            if (block.name.toLowerCase() === 'web imoc' || block.name) {
                header = block?.header;
                exposeCopy = block?.expose_copy;
                imocReadMoreCopy = `${block?.copy} ${block?.read_more_copy}`;
                imocShowSameDay = block?.show_same_day_cutoff_times;
                imageImoc = block?.image;
            }
        });
    }
    // set state
    const [toggle, setToggle] = useState(exposeCopy || false);
    const flowerPresentation = presentation_family === 'flower';
    const imocInnerContainer = flowerPresentation ? classes.flowerInnerContainer : classes.innerContainer;
    const imocButton = flowerPresentation ? classes.flowerImocClose : classes.imocClose;
    const imocReadMore = flowerPresentation ? classes.flowerImocReadMoreCopy : classes.imocReadMoreCopy;
    if (header || imageImoc) {
        return (
            <>
                {imocShowSameDay && <CountDownTimerBanner samedayCutoff={samedayCutoff} />}
                <div data-testid="mobile-imoc" className={`${classes.mobileImocContainer} ${brandData?.code === 'CAN' ? classes.mobileImocBackgorundContainer : ''}`}>
                    <div className={imocInnerContainer}>
                        {imageImoc ? (
                            <img src={imageImoc?.url} className={classes.imgLogo} alt={title} />
                        ) : (
                            <h1>{header}</h1>)}
                    </div>
                    <div className={imocButton}>
                        {language === '/en'
                            ? <button type="button" className={classes.toggleButton} onClick={() => setToggle(!toggle)}>{toggle ? 'close' : 'Read more'}</button>
                            : <button type="button" className={classes.toggleButton} onClick={() => setToggle(!toggle)}>{toggle ? dataDictionary.close : dataDictionary['Read more']}</button>}
                    </div>
                    <div className={toggle ? classes.moreText : classes.lessText}>
                        <ReactMarkdown
                            source={imocReadMoreCopy}
                            skipHtml
                            className={imocReadMore}
                        />
                        {imocShowSameDay && <div style={{ paddingBottom: '20px' }}><DeliveryTable samedayCutoff={samedayCutoff} /></div>}
                    </div>
                </div>
            </>
        );
    }
    return null;
};

MobileImoc.propTypes = {
    imocBlock: arrayOf(
        shape({
            header: string.isRequired,
            expose_copy: bool.isRequired,
            copy: string.isRequired,
            read_more_copy: string,
            show_same_day_cutoff_times: bool.isRequired,
        }),
    ).isRequired,
    classes: object.isRequired,
    presentation_family: string.isRequired,
    samedayCutoff: shape({
        entries: arrayOf(shape({
            cutoff_entries: array,
        })),
    }),
    brandData: shape({
        code: string,
    }),
    language: string.isRequired,
    dataDictionary: object.isRequired,
};
const mapStateToProps = (state) => ({
    presentation_family: getPresentationFamily(state),
    brandData: getBrand(state),
    dataDictionary: getDataDictionary(state),
});
const enhance = compose(
    connect(mapStateToProps),
);
MobileImoc.defaultProps = {
    samedayCutoff: {},
    brandData: null,
};
export default enhance(withStyles(styles)(MobileImoc));
